var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
import "../models/index.js";
import { TreatmentVariableType, FlightType, StageTrafficSource, ProgressionCategory } from "../models/FeatureDataModel.js";
import { OperatorCategory } from "../models/TrafficFilterModel.js";
const getDefaultOperationCheck = () => {
  return {
    status: AsyncRequestStatus.Pending,
    data: {
      error: null,
      errorDetails: null,
      lastUpdatedTime: null,
      operationCheckDictionary: null
    }
  };
};
const getDefaultCompletedOperationCheck = () => {
  return __spreadProps(__spreadValues({}, getDefaultOperationCheck()), {
    status: AsyncRequestStatus.Completed
  });
};
const getDefaultOperationState = () => {
  return {
    status: AsyncRequestStatus.Completed,
    data: {
      state: null
    }
  };
};
const getDefaultFeatureMetadata = () => {
  return {
    id: null,
    isInitialized: false,
    isHidden: false,
    name: "",
    owners: [],
    workspaceId: null,
    managementGroup: null,
    description: "",
    treatmentVariableEnabled: false,
    treatmentVariableNamespace: null,
    treatmentVariableNamespacePrefix: null,
    isControlEnabledDefault: true,
    canDisableControlFlight: false,
    isolationGroups: [],
    assignmentUnits: [],
    selectedAssignmentUnit: null,
    operationCheck: getDefaultOperationCheck(),
    isProgressionAllowed: true,
    useLegacyRollout: false,
    legacyRolloutMigrated: false,
    makeLegacyRolloutReadOnly: false,
    gatesMetadata: null,
    canRestartProgressionStage: false,
    enableOverrideTargets: false,
    controlTowerTenant: null,
    enableEmergencyShutdown: false,
    selectedSubscriptions: null,
    subscriptionOptions: [],
    enableSubscriptionSelection: false,
    defaultSubscriptions: [],
    isFlightCountersEnabled: false,
    enableIsolationGroupSelection: false,
    isolationGroupOptions: [],
    isAutoGeneratedIsolationGroup: true,
    autoGeneratedIsolationGroup: null,
    enableComboFlight: false,
    customProperties: {},
    userHasWritePermission: false,
    flightNameLengthReservedBySystem: 4,
    maxFlightNameLength: 20
  };
};
const getDefaultTreatmentVariable = (namespace) => {
  return {
    name: "",
    type: TreatmentVariableType.Boolean,
    value: "",
    namespace: namespace || ""
  };
};
const getDefaultFlight = (isolationGroups, treatmentVariableEnabled, isControlEnabled, name, namespace) => {
  const treatmentVariables = [];
  if (treatmentVariableEnabled) {
    treatmentVariables.push(getDefaultTreatmentVariable(namespace));
  }
  return {
    name: name || "",
    type: FlightType.Treatment,
    isValidating: false,
    isControlEnabled,
    treatmentVariables,
    isCreated: false,
    isolationGroups,
    composition: [],
    isSaved: false
  };
};
const getDefaultFlightForControl = (isolationGroups, treatmentVariableEnabled, isControlEnabled, name, namespace) => {
  const treatmentVariables = [];
  if (treatmentVariableEnabled) {
    treatmentVariables.push(getDefaultTreatmentVariable(namespace));
  }
  return {
    name: name || "",
    type: FlightType.CustomControl,
    isValidating: false,
    isControlEnabled,
    treatmentVariables,
    isCreated: false,
    isolationGroups,
    composition: []
  };
};
const getDummyTrafficStage = () => {
  return getTrafficStage(50, "F1");
};
const getTrafficStage = (traffic, flight, stepType) => {
  return {
    id: "",
    startDate: null,
    state: "New",
    scorecardLink: "https://localhost",
    stepIds: [],
    stepTypes: stepType ? [stepType] : [],
    endDate: null,
    scorecards: null,
    trafficSource: StageTrafficSource.templateDefined,
    flightAllocationIdsMap: {},
    gatingEntityId: "",
    flightTrafficMap: {
      [flight]: traffic,
      [`${flight}cf`]: traffic >= 50 ? 0 : traffic
    },
    flightTypeMap: {
      [flight]: FlightType.Treatment,
      [`${flight}cf`]: FlightType.CustomControl
    }
  };
};
const getDefaultProgressionStage = () => {
  return __spreadProps(__spreadValues({}, progressionStage()), {
    restartedFrom: __spreadValues({}, progressionStage())
  });
};
const progressionStage = () => {
  return {
    id: "",
    sequenceIndex: 0,
    mdsSequenceIndex: 0,
    friendlyName: "progression name",
    state: {
      FriendlyLabel: "New",
      State: "new",
      FrontierStageIndex: 0,
      FrontierIsLastStage: true
    },
    stages: [getDummyTrafficStage(), getDummyTrafficStage()],
    trafficFilters: {
      trafficFilters: {}
    },
    initialTrafficFilters: {
      trafficFilters: {}
    },
    operationCheck: getDefaultOperationCheck(),
    journals: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    isolationGroups: []
  };
};
const getDummyDefaultProgression = (id, isolationGroups, treatmentVariableEnabled, isControlEnabled) => {
  return {
    id,
    flights: [getDefaultFlight(isolationGroups, treatmentVariableEnabled, isControlEnabled)],
    name: "",
    category: ProgressionCategory.Restricted,
    state: {
      FriendlyLabel: "New",
      State: "new",
      FrontierStageIndex: 0,
      FrontierIsLastStage: true
    },
    templateName: "",
    filteredProgressionStages: [getDefaultProgressionStage(), getDefaultProgressionStage()],
    allProgressionStages: [getDefaultProgressionStage(), getDefaultProgressionStage()],
    progressionFilters: {
      trafficFilters: {}
    },
    created: null,
    configProviderInfo: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    isArchived: false
  };
};
const getDefaultOverrideSet = () => {
  return {
    id: null,
    stages: [],
    operationCheck: getDefaultOperationCheck()
  };
};
const getDefaultOverride = () => {
  return {
    id: null,
    overrideName: null,
    flightName: null,
    trafficFilters: null,
    priority: null,
    overrideType: null
  };
};
const getInitialFlightList = () => {
  return {
    flights: [getDefaultFlight([], false, true)],
    explicitControlFlights: false
  };
};
const getInitialProgressionCloneGroups = () => {
  return {};
};
const getDefaultTrafficFilter = () => {
  return {
    currentValue: {
      clause: []
    },
    displayName: null,
    htmlDescription: null,
    isEditable: false,
    isRequired: false,
    operatorCategory: OperatorCategory.InOnly,
    valueOption: null
  };
};
const getDefaultValueOption = () => {
  return {
    type: null,
    placeholder: null,
    predfinedValues: []
  };
};
const getDummyFeatureRolloutBackend = () => {
  return {
    Name: "string",
    Description: "Description",
    IsHidden: false,
    WorkspaceId: "workspace",
    ManagementGroup: "mg",
    Tenant: "tenant",
    Owners: [],
    Flights: [],
    AssignmentUnit: "",
    Extensions: {}
  };
};
const getDummyFlightBackend = () => {
  return {
    IsolationGroups: []
  };
};
export {
  getDefaultCompletedOperationCheck,
  getDefaultFeatureMetadata,
  getDefaultFlight,
  getDefaultFlightForControl,
  getDefaultOperationCheck,
  getDefaultOperationState,
  getDefaultOverride,
  getDefaultOverrideSet,
  getDefaultProgressionStage,
  getDefaultTrafficFilter,
  getDefaultTreatmentVariable,
  getDefaultValueOption,
  getDummyDefaultProgression,
  getDummyFeatureRolloutBackend,
  getDummyFlightBackend,
  getDummyTrafficStage,
  getInitialFlightList,
  getInitialProgressionCloneGroups,
  getTrafficStage,
  progressionStage
};
//# sourceMappingURL=FeatureInitialData.js.map
